<template>
  <my-view :GetWechatQrCode="GetWechatQrCode" :GetUserByPlat="GetUserByPlat" :UnBindWechat="UnBindWechat"></my-view>
</template>

<script>
import {
  GetWechatQrCode,
  GetUserByPlat,
  UnBindWechat,
} from "@/pages/page1/api/modules/user";

import MyView from "@/pages/publicView/personalCenter/userBind_view.vue";

export default {
  components: { MyView },
  data() {
    return {
      GetWechatQrCode,
      GetUserByPlat,
      UnBindWechat,
    };
  },
};
</script>